import { render, staticRenderFns } from "./AutoPlayVideo.vue?vue&type=template&id=249de8fa&scoped=true"
import script from "./AutoPlayVideo.vue?vue&type=script&lang=ts"
export * from "./AutoPlayVideo.vue?vue&type=script&lang=ts"
import style0 from "./AutoPlayVideo.vue?vue&type=style&index=0&id=249de8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249de8fa",
  null
  
)

export default component.exports